import { TextField } from '@material-ui/core'
import cn from 'classnames'
import styles from './VNItemDetailOpenPrice.module.scss'
import { makeStyles } from '@material-ui/core/styles'
import { useEffect, useRef } from 'react'
import { NOTES_CHARACTER_LIMIT } from '../../constants'
import VNOpenPriceNotice from './VNOpenPriceNotice'

const textFieldStyles = makeStyles({
  root: {
    //focused color for input with variant='outlined'
    '& .MuiOutlinedInput-root': {
      '&.MuiInputBase-formControl fieldset': {
        border: 0,
      },
      '&.Mui-focused fieldset': {
        border: 0,
      },
    },
  },
})

const VNItemDetailOpenPrice = ({ openPrice, handleSetOpenPrice, openName, handleSetOpenName, itemName, onFocus, onBlur }) => {
  const classes = textFieldStyles()
  const openPriceRef = useRef()
  const openNameRef = useRef()

  useEffect(() => {
    if (openPriceRef.current) {
      openPriceRef.current.focus()
    }
  }, [])

  const handleOpenPriceChange = (event) => {
    const input = event.target.value?.replace(/\D/g, '')
    const formattedValue = (parseInt(input, 10) / 100 || 0).toFixed(2)

    handleSetOpenPrice(formattedValue)

    const cursorPosition = event.target.selectionStart
    const valueLength = formattedValue.length + 1
    if (cursorPosition <= 4) {
      setTimeout(() => {
        event.target.setSelectionRange(valueLength, valueLength)
      }, 0)
    }
  }

  const handleOpenNameOnFocus = () => {
    //only select all text when the item name is the same as the item open name
    if (openNameRef.current && itemName === openName) {
      openNameRef.current.select()
    }
    onFocus()
  }

  const handleOnEnter = (event, hasNext) => {
    if (event.key !== 'Enter') return

    event.preventDefault()
    if (hasNext) {
      openNameRef.current.focus()
      return
    }

    openNameRef.current.blur()
    onBlur()
  }

  const handleOpenNameChange = (event) => {
    if (event.target.value.length <= NOTES_CHARACTER_LIMIT) {
      handleSetOpenName(event.target.value || '')
    }
  }

  return (
    <div className={styles.container}>
      <VNOpenPriceNotice />
      <div className={styles.border__container}>
        <div className={cn(styles.field__container)}>
          <TextField
            inputRef={openPriceRef}
            id="item-price"
            type="tel"
            label="Item Price"
            value={openPrice}
            onChange={handleOpenPriceChange}
            className={cn(styles.input, classes.root)}
            InputLabelProps={{
              className: styles.textfield__label,
              classes: { shrink: styles.textfield__label__shrink },
            }}
            inputProps={{ 'data-allow-keyboard-activity': true }}
            InputProps={{
              className: styles.textfield__input,
              startAdornment: <span style={{ marginRight: '5px' }}>$</span>,
            }}
            variant="outlined"
            onFocus={onFocus}
            onBlur={onBlur}
            onKeyDown={(e) => handleOnEnter(e, true)}
          />
        </div>
      </div>
      <div className={styles.border__container}>
        <div className={cn(styles.field__container)}>
          <TextField
            inputRef={openNameRef}
            id="item-name"
            label="Item Name"
            value={openName}
            onChange={handleOpenNameChange}
            className={cn(styles.input, classes.root)}
            InputLabelProps={{
              className: styles.textfield__label,
              classes: { shrink: styles.textfield__label__shrink },
            }}
            inputProps={{ 'data-allow-keyboard-activity': true }}
            InputProps={{ className: styles.textfield__input }}
            variant="outlined"
            onFocus={handleOpenNameOnFocus}
            onBlur={onBlur}
            onKeyDown={handleOnEnter}
          />
        </div>
      </div>
    </div>
  )
}

export default VNItemDetailOpenPrice
